import { graphql } from 'gql';

export const getWorkOrderOtherForDistribution = graphql(`
    query uerWorkOrderOtherForDistribution($workOrderId: Long!, $workOrderOtherPriceId: Long!) {
        uerWorkOrderOtherForDistribution(workOrderId: $workOrderId, workOrderOtherPriceId: $workOrderOtherPriceId) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
            data {
                contractOtherCost {
                    id
                    key
                    canDelete
                    canEdit
                    isInUse
                    name
                    calculatingType
                    calculatingTypeValue
                    chapter
                    section
                    isGlobalOtherCost
                    status
                    isInUse
                    canEdit
                    canDelete
                }
                limits {
                    includedCost
                    isIncluded
                    season {
                        id
                        year
                    }
                    costLimit
                    totalRemainderCost
                    deviation
                    isSystemCalculation
                }
                workOrderObjects {
                    canAddOther
                    canRemoveOther
                    contractObjectId
                    hasActsKC2
                    hasActualCost
                    isActKC2Cost
                    isIncluded
                    name
                    rationale
                    workOrderRootObjectId
                }
                objectSeasonDistributions {
                    isIncluded
                    hasErrors
                    errors
                    objectId
                    seasonId
                    cost
                }
            }
        }
    }
`);

export const gqlUpdateWorkOrderOtherCost = graphql(`
    mutation uerUpdateWorkOrderOtherDistribution(
        $workOrderOtherPriceId: Long!
        $updateInput: WorkOrderOtherDistributionUpdateInput!
    ) {
        uerUpdateWorkOrderOtherDistribution(workOrderOtherPriceId: $workOrderOtherPriceId, updateInput: $updateInput) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updateWorkOrderActOtherDistributionGql = graphql(`
    mutation uerUpdateWorkOrderOtherDistributionToActKC2(
        $workOrderOtherPriceId: Long!
        $updateInput: WorkOrderOtherDistributionUpdateInput!
    ) {
        uerUpdateWorkOrderOtherDistributionToActKC2(
            workOrderOtherPriceId: $workOrderOtherPriceId
            updateInput: $updateInput
        ) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const calcWorkOrderDistributionGql = graphql(`
    query uerCalcWorkOrderOtherDistribution($workOrderOtherPriceId: Long!, $input: WorkOrderOtherPriceCalcInput!) {
        uerCalcWorkOrderOtherDistribution(workOrderOtherPriceId: $workOrderOtherPriceId, input: $input) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
            data {
                isIncluded
                hasErrors
                errors
                objectId
                seasonId
                cost
            }
        }
    }
`);

export const uerCalcWorkChangeOrderOtherDistributionGql = graphql(`
    query uerCalcWorkOrderChangeOtherDistribution(
        $workOrderChangeId: Long!
        $workOrderChangeOtherPriceId: Long
        $workOrderOtherPriceId: Long
        $input: WorkOrderChangeOtherPriceCalcInput!
    ) {
        uerCalcWorkOrderChangeOtherDistribution(
            workOrderChangeId: $workOrderChangeId
            workOrderChangeOtherPriceId: $workOrderChangeOtherPriceId
            workOrderOtherPriceId: $workOrderOtherPriceId
            input: $input
        ) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
            data {
                isIncluded
                hasErrors
                errors
                seasonId
                cost
                workOrderChangeObjectId
                workOrderObjectId
            }
        }
    }
`);
